module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/87924d6354694a1b40c4404b39f783d7.png";